import "../../../features/filterValues/api/api.js";
import "../../../features/filterValues/model/middleware/index.js";
import { selectAllFilterValues } from "../../../features/filterValues/model/selectors/selectAllFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../features/filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../../features/filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterItems.js";
import "../../../features/filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../features/filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectIsFilterValuesMissing.js";
import "react";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "@perxis-auto/shared";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import { selectFilters } from "../../../shared/store/installation/model/selectors/selectFilters.js";
import "../../../shared/store/installation/model/slice.js";
import "../../../shared/store/installation/middleware/index.js";
import { useGetVehiclesQuery } from "../api/api.js";
import "../model/selectors/selectIsVehiclesDataMissing.js";
import "../model/selectors/selectVehicle.js";
import "../model/selectors/selectVehicleParameters.js";
import "../model/selectors/selectVehicles.js";
import "../model/selectors/selectVehiclesCount.js";
import { selectVehiclesParameters } from "../model/selectors/selectVehiclesParameters.js";
import "../model/selectors/selectVehiclesTotalPages.js";
const useGetVehicles = ({ offset }) => {
  const { ready: isFiltersReady } = useAppSelector(selectFilters);
  const vehiclesParameters = useAppSelector((state) => selectVehiclesParameters(state, offset));
  const allFilterValuesQueryResult = useAppSelector(selectAllFilterValues);
  const isSkip = !allFilterValuesQueryResult.data || !isFiltersReady;
  const queryResult = useGetVehiclesQuery(vehiclesParameters, {
    skip: isSkip
  });
  return queryResult;
};
export {
  useGetVehicles
};
